import qwest from 'qwest';

let ArticleApi = {
  favoriteShelfArticle(id) {
    return qwest.get(`/Article/SetFavoriteShelfArticle/?gemID=${id}`).then((xhr, response) => {
      if (response.success) {
        return true;
      }

      throw response;
    });
  },

  unFavoriteShelfArticle(id) {
    return qwest.delete(`/Article/RemoveFavoriteShelfArticle/?gemID=${id}`).then((xhr, response) => {
      if (response.success) {
        return true;
      }

      throw response;
    });
  },
};

export default ArticleApi;
